import type { MetadataStringConfig } from './CSVStringSelector.js'

export const SequencingDepthConfig: MetadataStringConfig = {
  label: "Sequencing Depth",
  type: "sequencingDepth",
  helpText: "Select column containing sequencing depth information",
  setter: (p, value) => { p.sequencingDepth = value },
}